import useGetLinkedProviders from './useGetLinkedProviders'
export default useGetLinkedProviders
